import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { type ReduxDispatchShared, type ReduxStateShared } from '~shared/types';

// Use instead of plain `useDispatch` and `useSelector`
export const useDispatchShared: () => ReduxDispatchShared = useDispatch;
export const useSelectorShared: TypedUseSelectorHook<ReduxStateShared> = useSelector;
